import {DeliveryGroupState} from '../interfaces'

export const getInitialState = (): DeliveryGroupState => ({
    deliveryGroupsByKey: {},
})
